import React, { createRef, useEffect, useRef, useState } from 'react';
import './Top.scss';
import { useHistory, useLocation } from 'react-router-dom';
import firebase from 'firebase';
import { auth, db, googleAuthProvider } from '../../../firebase';
import { ICONS } from '../../../constants/icons';
import { useDataLayerValue } from '../../../DataLayer';


function Top(props) {

    let history = useHistory();
    let location = useLocation();
    const [{ user, lang }, dispatch] = useDataLayerValue();
    const [isShowDropdown, setIsShowDropdown] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const refSearch = useRef(null);
    const refDropdown = createRef(null);

    const handleGoForward = () => {
        history.goForward();
    };
    const handleGoBack = () => {
        history.goBack();
    }
    const handleSignin = () => {
        auth.signInWithRedirect(googleAuthProvider);
    };

    const authListenner = () => {
        auth.onAuthStateChanged(async (user) => {
            if (user) {
                const info = { ...user.providerData[0], token: user.refreshToken, user_uid: user.uid };
                dispatch({
                    type: 'SET_USER',
                    user: info
                });
                // Get list song love
                db.collection("users").doc(info.user_uid)
                    .get()
                    .then(async function (doc) {
                        if (doc.exists) {
                            //Get play list song love when user used to register before
                            let infoUser = { ...doc.data(), id: doc.id };
                            await dispatch({
                                type: 'SET_PLAYLIST_SONG_LOVE',
                                playlist_song_love: infoUser.playlist_love_song ? infoUser.playlist_love_song : []
                            });
                        } else {
                            //Add new user when user dont register before
                            const docCreateDataUser = {
                                ...info,
                                playlist_love_song: [],
                                reducer: [],
                                level: 0,
                                created_at: firebase.firestore.Timestamp.now(),
                                updated_at: firebase.firestore.Timestamp.now(),
                            };
                            await db.collection("users").doc(info.user_uid).set(docCreateDataUser);

                        }
                    }).catch(function (error) {
                        console.log("Error getting document detail user");
                        history.push('/error');
                    });
            } else {
                dispatch({
                    type: 'SET_USER',
                    user: null
                });
            }
        });
    };

    const handleShowDropdown = () => {
        setIsShowDropdown(!isShowDropdown);
    };

    const handleLogOut = async () => {
        await auth.signOut();
        dispatch({
            type: 'SET_USER',
            user: null
        });
        dispatch({
            type: 'SET_PLAYLIST_SONG_LOVE',
            playlist_song_love: []
        });
        return history.push('/');
    };

    const handlenMouseOver = () => {
        setIsShowDropdown(false);
    };

    const handleChangeLang = (lang) => {
        if (lang) {
            dispatch({
                type: 'SET_LANG',
                lang: lang
            });
        }
    };

    const handleSearch = (searchV) => {
        setSearchValue(searchV);
        if (refSearch.current) {
            clearTimeout(refSearch.current);
        }
        refSearch.current = setTimeout(() => {
            dispatch({
                type: 'SET_SEARCH',
                search: searchV
            });
        }, 400);
    };

    const handleClearValueSearch = () => {
        setSearchValue('');
        if (refSearch.current) {
            clearTimeout(refSearch.current);
        }
        dispatch({
            type: 'SET_SEARCH',
            search: ''
        });
    };


    useEffect(() => {
        authListenner();
    }, []);

    return (
        <div className="right-container__header">
            <div className="right-container__header--left">
                <button aria-hidden="true" disabled="" className="top-bar-back-button" title="Go back" onClick={handleGoBack} >
                    <svg role="img" focusable="false" height="24" width="24" viewBox="0 0 24 24" className="">
                        <polyline points="16 4 7 12 16 20" fill="none" stroke="#fff"></polyline>
                    </svg>
                </button>
                <button aria-hidden="true" disabled="" className="top-bar-forward-button" title="Go forward" onClick={handleGoForward}>
                    <svg role="img" focusable="false" height="24" width="24" viewBox="0 0 24 24" className="">
                        <polyline points="8 4 17 12 8 20" fill="none" stroke="#fff"></polyline>
                    </svg>
                </button>
                {
                    location.pathname === '/search' && (<div className="right-container__header--search">
                        <input className="input-search" placeholder={`${lang === 'en' ? 'Search for Songs' : 'Tìm kiếm bài hát'}`} value={searchValue} onChange={(e) => handleSearch(e.target.value)} />
                        <span className="icon-search">
                            <svg height="24" role="img" width="24" viewBox="0 0 512 512" aria-hidden="true"><path d="M349.714 347.937l93.714 109.969-16.254 13.969-93.969-109.969q-48.508 36.825-109.207 36.825-36.826 0-70.476-14.349t-57.905-38.603-38.603-57.905-14.349-70.476 14.349-70.476 38.603-57.905 57.905-38.603 70.476-14.349 70.476 14.349 57.905 38.603 38.603 57.905 14.349 70.476q0 37.841-14.73 71.619t-40.889 58.921zM224 377.397q43.428 0 80.254-21.461t58.286-58.286 21.461-80.254-21.461-80.254-58.286-58.285-80.254-21.46-80.254 21.46-58.285 58.285-21.46 80.254 21.46 80.254 58.285 58.286 80.254 21.461z" fill="currentColor"></path></svg>
                        </span>
                        {
                            searchValue.trim() !== '' && <span className="icon-close" onClick={handleClearValueSearch}>
                                <svg height="24" role="img" width="24" viewBox="0 0 24 24"  ><path d="M4.93,4.93,19.07,19.07m-14.14,0L19.07,4.93" fill="none" stroke="currentColor" strokeMiterlimit="10"></path></svg>
                            </span>
                        }

                    </div>)
                }

            </div>
            <div className={`topbar-content-wrapper ${location.pathname === '/search' && window.innerWidth <= 600 ? 'd-none' : ''}`}>
                {/* <button className="btn_upgrade_to_premium" type="button" aria-label="Upgrade to Premium" title="">{lang === 'en' ? 'Upgrade' : 'Nâng cấp'}</button> */}
                {user === null ? (<button className="btn_upgrade_to_login" type="button" aria-label="Upgrade to Login" title="login with google" onClick={handleSignin}> <img src={ICONS.google} alt="logo-google" className="logo-google-top" /> {lang === 'en' ? (window.innerWidth <= 600 ? 'Login' : 'Login With Google') : (window.innerWidth <= 600 ? 'Đăng nhập' : 'Đăng nhập với Google')} </button>)
                    : (<div className="dropdown-account-topbar">
                        <button className="user-widget-link" type="button" aria-expanded="false" onClick={handleShowDropdown} ref={refDropdown}>
                            <figure className="user-widget-avatar">
                                {user !== null && user.photoURL !== null ? (<img className="top-avatar-user" src={user.photoURL} alt="avatar user" />) :
                                    (<svg width="16" height="16" fill="currentColor" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg" data-testid="user-icon">
                                        <path d="M15.216 13.717L12 11.869C11.823 11.768 11.772 11.607 11.757 11.521C11.742 11.435 11.737 11.267 11.869 11.111L13.18 9.57401C14.031 8.58001 14.5 7.31101 14.5 6.00001V5.50001C14.5 3.98501 13.866 2.52301 12.761 1.48601C11.64 0.435011 10.173 -0.0879888 8.636 0.0110112C5.756 0.198011 3.501 2.68401 3.501 5.67101V6.00001C3.501 7.31101 3.97 8.58001 4.82 9.57401L6.131 11.111C6.264 11.266 6.258 11.434 6.243 11.521C6.228 11.607 6.177 11.768 5.999 11.869L2.786 13.716C1.067 14.692 0 16.526 0 18.501V20H1V18.501C1 16.885 1.874 15.385 3.283 14.584L6.498 12.736C6.886 12.513 7.152 12.132 7.228 11.691C7.304 11.251 7.182 10.802 6.891 10.462L5.579 8.92501C4.883 8.11101 4.499 7.07201 4.499 6.00001V5.67101C4.499 3.21001 6.344 1.16201 8.699 1.00901C9.961 0.928011 11.159 1.35601 12.076 2.21501C12.994 3.07601 13.5 4.24301 13.5 5.50001V6.00001C13.5 7.07201 13.117 8.11101 12.42 8.92501L11.109 10.462C10.819 10.803 10.696 11.251 10.772 11.691C10.849 12.132 11.115 12.513 11.503 12.736L14.721 14.585C16.127 15.384 17.001 16.884 17.001 18.501V20H18.001V18.501C18 16.526 16.932 14.692 15.216 13.717Z"></path>
                                    </svg>)
                                }
                            </figure>
                            <span className="user-widget-name" as="span" >{user !== null && user.displayName !== null ? user.displayName : ''}</span>
                            <svg className="user-widget-show-more" role="img" height="16" width="16" viewBox="0 0 16 16" fill="currentcolor"><path d="M3 6l5 5.794L13 6z"></path></svg>
                        </button>
                        {isShowDropdown && <ul className="dropdown-account-menu">
                            <li>
                                <div className="menu-lang">
                                    <span className={`lang-icon ${lang === 'en' ? 'lang-active' : ''}`} onClick={() => handleChangeLang('en')}> <img src={ICONS.lang_en} alt="lang english" /></span>
                                    <span className={`lang-icon ${lang === 'vi' ? 'lang-active' : ''}`} onClick={() => handleChangeLang('vi')}> <img src={ICONS.lang_vi} alt="lang vietnam" /></span>
                                </div>
                            </li>
                            <li>{lang === 'en' ? 'Acount' : 'Tài khoản'}</li>
                            <li onClick={handleLogOut}>{lang === 'en' ? 'Log out' : 'Đăng xuất'}</li>
                        </ul>}
                    </div>)
                }
            </div>
        </div>
    );
}

export default Top;